// extracted by mini-css-extract-plugin
export default {"txx":"style_txx__6Q0ZZ"};